import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_11 = { class: "admin-search-box" }
const _hoisted_12 = { class: "admin-right-sidebar-in-top-right-btm" }
const _hoisted_13 = { class: "tags" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "delete-all-btn-link"
}
const _hoisted_16 = { class: "admin-item-list-section email-logs-section" }
const _hoisted_17 = { class: "admin-item-list-section-in" }
const _hoisted_18 = { class: "admin-item-list-section-scroll" }
const _hoisted_19 = { class: "admin-item-list-top" }
const _hoisted_20 = { class: "admin-item-list-row" }
const _hoisted_21 = { class: "admin-item-checkbox" }
const _hoisted_22 = { class: "admin-checkbox-input" }
const _hoisted_23 = { class: "email-logs-from" }
const _hoisted_24 = { class: "email-logs-action" }
const _hoisted_25 = { class: "admin-item-list-btm" }
const _hoisted_26 = { class: "admin-item-box-top" }
const _hoisted_27 = { class: "admin-item-list-row" }
const _hoisted_28 = { class: "admin-item-checkbox" }
const _hoisted_29 = { class: "admin-checkbox-input" }
const _hoisted_30 = ["id", "onChange", "checked"]
const _hoisted_31 = ["for"]
const _hoisted_32 = { class: "email-logs-date-time" }
const _hoisted_33 = { class: "email-logs-to" }
const _hoisted_34 = { class: "email-logs-subject text-limit" }
const _hoisted_35 = { class: "email-logs-action" }
const _hoisted_36 = { class: "admin-action-link" }
const _hoisted_37 = ["onClick", "disabled"]
const _hoisted_38 = ["onClick", "disabled"]
const _hoisted_39 = { class: "admin-item-box-btm" }
const _hoisted_40 = { class: "email-log-content" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "email-log-item" }
const _hoisted_43 = { class: "email-log-date" }
const _hoisted_44 = { class: "email-log-item" }
const _hoisted_45 = { class: "email-log-item" }
const _hoisted_46 = { class: "email-log-full-message" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = {
  key: 0,
  class: "no-data-message"
}
const _hoisted_49 = { class: "admin-pagination-section" }
const _hoisted_50 = { class: "custom-row" }
const _hoisted_51 = { class: "item-show-selectbox" }
const _hoisted_52 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_55 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "confirmation-popup-mid" }
const _hoisted_58 = { class: "confirmation-popup-btm" }
const _hoisted_59 = {
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_EMAIL_LOGS_TEXT), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        id: "seachEmailTempalteInput",
                        type: "text",
                        placeholder: "Search Email Logs",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.fetchEmailLogs(), _ctx.selectAll = false, _ctx.selectedEmailLogs = [], _ctx.fetchCounts()), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("ul", null, [
                        (_ctx.selectedEmailLogs.length > 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedEmailLogs.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedEmailLogs = [], _ctx.selectAll = false))
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.selectedEmailLogs.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            name: "cssCheckbox",
                            id: "allCheckInput",
                            type: "checkbox",
                            class: "css-checkbox",
                            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleAllEmailLogsSelection && _ctx.toggleAllEmailLogsSelection(...args))),
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectAll) = $event))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.selectAll]
                          ]),
                          _cache[14] || (_cache[14] = _createElementVNode("label", { for: "allCheckInput" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "email-logs-date-time",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSort('Created_at'))),
                        style: {"cursor":"pointer"}
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.constants.DATE_LABEL) + " ", 1),
                        (_ctx.sortBy === 'Created_at' || _ctx.sortBy === '-Created_at')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-Created_at' }])
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.constants.FROM_LABEL), 1),
                      _createElementVNode("div", {
                        class: "email-logs-to",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleSort('email'))),
                        style: {"cursor":"pointer"}
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.constants.TO_LABEL) + " ", 1),
                        (_ctx.sortBy === 'email' || _ctx.sortBy === '-email')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-email' }])
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: "email-logs-subject",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleSort('subject'))),
                        style: {"cursor":"pointer"}
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.constants.SUBJECT_LABEL) + " ", 1),
                        (_ctx.sortBy === 'subject' || _ctx.sortBy === '-subject')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-subject' }])
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.constants.ACTION_LABEL), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailLogs, (emailLog, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: emailLog.id,
                        class: _normalizeClass(['admin-item-box', { 'show-edit-item': emailLog.isOpen }])
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("input", {
                                  name: "cssCheckbox",
                                  id: 'allCheckInput' + emailLog.id,
                                  type: "checkbox",
                                  class: "css-checkbox",
                                  onChange: ($event: any) => (_ctx.toggleSingleEmailLogSelection(emailLog.id)),
                                  checked: _ctx.selectedEmailLogs.includes(emailLog.id)
                                }, null, 40, _hoisted_30),
                                _createElementVNode("label", {
                                  for: 'allCheckInput' + emailLog.id
                                }, null, 8, _hoisted_31)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.formatDate(emailLog.Created_at)), 1),
                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "email-logs-from" }, "hr@lmdconsulting.com", -1)),
                            _createElementVNode("div", _hoisted_33, _toDisplayString(emailLog.email), 1),
                            _createElementVNode("div", _hoisted_34, _toDisplayString(emailLog.subject), 1),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("ul", _hoisted_36, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("button", {
                                    class: "editBtn",
                                    onClick: ($event: any) => (_ctx.viewEmailLog(emailLog, index)),
                                    disabled: emailLog.isOpen
                                  }, _toDisplayString(_ctx.constants.VIEW_BUTTON), 9, _hoisted_37)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("button", {
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#deletePop",
                                    onClick: ($event: any) => (_ctx.setDeleteMode('single', emailLog.id)),
                                    disabled: emailLog.isOpen
                                  }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_38)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("button", {
                              id: "closeBtn",
                              class: "emaillog-hide",
                              onClick: ($event: any) => (_ctx.closeEmailLog(index))
                            }, null, 8, _hoisted_41),
                            _createElementVNode("ul", null, [
                              _createElementVNode("li", null, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("label", null, _toDisplayString(_ctx.constants.FROM_LABEL), 1),
                                  _cache[16] || (_cache[16] = _createElementVNode("span", null, "hr@lmdconsulting.com", -1))
                                ]),
                                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.formatDate(emailLog.Created_at)), 1)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("label", null, _toDisplayString(_ctx.constants.SUBJECT_LABEL), 1),
                                  _createElementVNode("span", null, _toDisplayString(emailLog.subject), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("label", null, _toDisplayString(_ctx.constants.TO_LABEL), 1),
                                  _createElementVNode("span", null, _toDisplayString(emailLog.email), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", {
                                    innerHTML: emailLog.emailContent
                                  }, null, 8, _hoisted_47)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ]),
                  (_ctx.emailLogs.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("p", null, "No email logs found", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _withDirectives(_createElementVNode("select", {
                      id: "paginationSelectBox",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.limit) = $event)),
                      onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                    }, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("option", { value: "10" }, "10", -1),
                      _createElementVNode("option", { value: "20" }, "20", -1),
                      _createElementVNode("option", { value: "50" }, "50", -1),
                      _createElementVNode("option", { value: "100" }, "100", -1)
                    ]))], 544), [
                      [_vModelSelect, _ctx.limit]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                  ]),
                  (_ctx.totalPages > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("ul", null, [
                          (_ctx.currentPage !== 1)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                              }, [...(_cache[19] || (_cache[19] = [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "pagination-previous"
                                }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (_ctx.totalPages != 1)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: page,
                                  onClick: ($event: any) => (_ctx.changePage(page))
                                }, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: _normalizeClass({ active: _ctx.currentPage === page })
                                  }, _toDisplayString(page), 3)
                                ], 8, _hoisted_53))
                              }), 128))
                            : _createCommentVNode("", true),
                          (_ctx.currentPage !== _ctx.totalPages)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 2,
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                              }, [...(_cache[20] || (_cache[20] = [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "pagination-next"
                                }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("button", _hoisted_59, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}